<template>
    <div v-if="showLegend" class="legend-box">
      <div class="legend-title">
        图例
      </div>
      <div class="legend-container">
        <div class="legend-item">
          <div><img src="@/assets/image/legend.png"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Legend',
    data() {
      return {
        // 图例
        showLegend: true
      }
    },
    methods: {
      closeLegendBox() {
        this.showLegend = false
      }
    }
  }
  </script>
  <style scoped lang="less">
  .legend-box {
    position: fixed;
    /*z-index: 3000;*/
    bottom: 6px;
    right: 5px;
    width: 300px;
    height: 240px;
    background: rgb(255, 255, 255);
    border: solid 1px #ccc;
    border-radius: 5px;
    opacity:0.85;
    .legend-title {
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding-left: 5px;
      background: #eee;
      font-size: 15px;
      font-weight: 600;
      text-align: center;
    }
    .legend-container {
      display: flex;
      flex-direction: column;
      // padding: 5px;
      border-left: solid 1px #eee;
      font-size: 14px;
      .legend-item {
        display: flex;
        flex-direction: row;
        div {
          width: 200px;
          padding-left: 10px;
          text-align: center;
          img {
            width: 200px;
          }
          div {
            width: 12px;
            height: 12px;
            border-radius: 6px;
            background: rgb(149 44 44);
            margin: 8px 0 0 20px;
          }
        }
        span {
          padding-left: 10px;
        }
      }
    }
  }
  </style>
  
  